import { IQueryParameters, ISelectModel } from 'common/models';
import API from 'services/api';

interface IProps extends IQueryParameters {
  unitId: string;
}

export const getUnitPriceListServices = ({
  unitId,
  params,
}: IProps): Promise<ISelectModel<number>[]> =>
  API.get(`/api/accommodation/properties/units/${unitId}/price-list-service`, {
    params: { ...params },
  }).then(response => response?.data);
